<script setup>
import { useI18n } from 'vue-i18n';

import Avatar from 'dashboard/components-next/avatar/Avatar.vue';

defineProps({
  teammates: { type: Array, default: () => [] },
});

const emit = defineEmits(['select']);

const { t } = useI18n();

const HEAD_CELL_CLASS =
  'whitespace-nowrap px-4 py-2.5 text-start text-xs font-medium text-n-slate-10';
</script>

<template>
  <div
    v-if="!teammates.length"
    class="flex items-center justify-center py-16 rounded-xl outline outline-1 -outline-offset-1 outline-n-container bg-n-solid-2"
  >
    <span class="text-sm text-n-slate-11">
      {{ t('TEAM_PAGE.TEAMMATES.EMPTY') }}
    </span>
  </div>
  <div
    v-else
    class="overflow-hidden rounded-xl outline outline-1 -outline-offset-1 outline-n-container bg-n-solid-2"
  >
    <div class="overflow-x-auto">
      <table class="w-full min-w-[640px] border-collapse">
        <thead>
          <tr class="border-b border-n-weak bg-n-alpha-1">
            <th scope="col" :class="HEAD_CELL_CLASS">
              {{ t('TEAM_PAGE.TEAMMATES.COLUMNS.NAME') }}
            </th>
            <th scope="col" :class="HEAD_CELL_CLASS">
              {{ t('TEAM_PAGE.TEAMMATES.COLUMNS.EMAIL') }}
            </th>
            <th scope="col" :class="HEAD_CELL_CLASS">
              {{ t('TEAM_PAGE.TEAMMATES.COLUMNS.ROLE') }}
            </th>
            <th scope="col" :class="HEAD_CELL_CLASS">
              {{ t('TEAM_PAGE.TEAMMATES.COLUMNS.STATUS') }}
            </th>
          </tr>
        </thead>
        <tbody class="divide-y divide-n-weak">
          <tr
            v-for="teammate in teammates"
            :key="teammate.id"
            class="cursor-pointer hover:bg-n-alpha-1"
            @click="emit('select', teammate.id)"
          >
            <td class="px-4 py-3">
              <div class="flex items-center gap-2.5">
                <Avatar
                  :name="teammate.name"
                  :src="teammate.thumbnail"
                  :size="32"
                  rounded-full
                />
                <span class="text-sm font-medium truncate text-n-slate-12">
                  {{ teammate.name }}
                </span>
              </div>
            </td>
            <td class="px-4 py-3 text-sm text-n-slate-11">
              {{ teammate.email }}
            </td>
            <td class="px-4 py-3">
              <span
                class="inline-flex items-center h-6 px-2 text-xs font-medium rounded-md"
                :class="
                  teammate.isAdministrator
                    ? 'bg-n-violet-3 text-n-violet-11'
                    : 'bg-n-alpha-2 text-n-slate-11'
                "
              >
                {{ teammate.roleLabel }}
              </span>
            </td>
            <td class="px-4 py-3">
              <span class="flex items-center gap-2 text-sm text-n-slate-11">
                <span
                  class="rounded-full size-2 shrink-0"
                  :class="teammate.statusDotClass"
                />
                {{ teammate.statusLabel }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
